module.exports = __webpack_public_path__ + "assets/ccr-alt.ae6ad988.svg";